<template>
  <FormControl :label="label" :disabled="true">
    <input type="text" v-model="model[name]" class="form-control" :placeholder="label" readonly>
  </FormControl>
</template>

<script>
  import FormControl from './FormControl';
  import formControlMixin from './mixins/form-control.mixin.js';

  export default {
    name: 'text-readonly',
    props: ['label', 'model', 'name'],
    mixins: [formControlMixin],
    components: {
      FormControl
    },
    methods: {
      getValue() {
        return this.model[this.name];
      }
    }
  }
</script>
